import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import useStyles from "./styles";
import NumberTextField from "../NumberTextField";
import "./style.scss";
import Big from "big.js";
import noop from "../../../services/noop";

const NumberInputStepper = (props) => {
  const styles = useStyles(props);

  const handleIncrement = () => {
    if (props.errMsg) props.setError("");
    let val;
    if (props.value === "" || props.value < props.min) val = Big(props.min);
    else val = Big(props.value).plus(props.stepSize);
    props.setValue(val.toNumber());
  };

  const handleDecrement = () => {
    if (props.errMsg) props.setError("");
    let val;
    if (props.value > props.max) val = Big(props.max);
    else val = Big(props.value).minus(props.stepSize);
    props.setValue(val.toNumber());
  };

  return (
    <>
      <Button
        data-testid="stepper-minus-btn"
        classes={{ root: styles.stepperRoundButton }}
        variant="outlined"
        onClick={handleDecrement}
        disabled={
          (props.value === "" ? props.min : props.value) - props.stepSize <
          props.min
        }
      >
        &minus;
      </Button>
      <NumberTextField {...props} className={styles.sideMargin} />
      <Button
        data-testid="stepper-plus-btn"
        classes={{ root: styles.stepperRoundButton }}
        variant="outlined"
        onClick={handleIncrement}
        disabled={
          (props.value === "" ? props.min : props.value) + props.stepSize >
          props.max
        }
      >
        +
      </Button>
    </>
  );
};

NumberInputStepper.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  stepSize: PropTypes.number,
  setError: PropTypes.func.isRequired,
  errMsg: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  questionId: PropTypes.string.isRequired,
  // addInvalidQuestion: PropTypes.func.isRequired,
  // removeInvalidQuestion: PropTypes.func.isRequired,
};

NumberInputStepper.defaultProps = {
  min: 0,
  max: 100,
  stepSize: 1,
  setError: noop,
  errMsg: "",
  setValue: noop,
  // addInvalidQuestion: noop,
  // removeInvalidQuestion: noop,
  questionId: "",
};

export default NumberInputStepper;
